import React from 'react';

import { connect } from 'react-redux';



import withLoader from 'components/Shared/withLoader';
import ReclamationDrawerListItem from '../ReclamationDrawerListItem';
const ReclamationDrawerListItemWithLoader = withLoader(ReclamationDrawerListItem);


function HistoriqueDrawerListItemContainer({ reclamationId, href, icon, isSelected, nbActionsSansReponse, isLoading  }) {


    return (
        <ReclamationDrawerListItemWithLoader
            isLoading={isLoading}
            title={nbActionsSansReponse ? `Historique (${nbActionsSansReponse})` : `Historique`}

            href={href}
            icon={icon}
            isSelected={isSelected}
        />
    );
}



const mapStateToProps = state => ({
    isLoading: state.reclamation.details.isLoading,
    nbActionsSansReponse: state.reclamation.details.item.nbActionsSansReponse
});


export default connect(mapStateToProps, null)(HistoriqueDrawerListItemContainer);